import React from 'react'
import PropTypes from 'prop-types'
import { AnimatePresence, motion } from 'framer-motion'
import { isEmpty } from 'lodash'
import { sliderTransition, sliderVariants } from './const'
import useOurProperties from './useOurProperties'
import Skeleton from './components/Skeleton'
import SelectAic from '@/components/shared/components/selectAic'
import Button from '@/components/shared/components/Button/Button'
import './styles.scss'

OurProperties.propTypes = {
  data: PropTypes.object,
}

const activeColor = '#fff'

export default function OurProperties({ data }) {
  const {
    currentProperty,
    onChangeHotel,
    properties,
    swipeToImage,
    direction,
    activeImageIndex,
    dragEndHandler,
    imageCount,
    currentImage,
    allLoading,
    loadingHotelSelected,
  } = useOurProperties()

  if (allLoading || loadingHotelSelected)
    return (
      <section className="our-properties h-screen aic-2k:h-[940px] bg-gray-500">
        <div className="main-container flex flex-col h-full">
          <div className="mt-[130px] md:mt-[108px] mb-auto our-properties__header">
            <h3 className="heading2 text-[45px] md:text-[60px] lg:text-[70px] leading-none uppercase text-white mb-5">
              {data?.title}
            </h3>

            <SelectAic
              light
              isLoading
              options={properties}
              value={currentProperty}
              onChange={(data) => {
                onChangeHotel(data)
              }}
            />
          </div>
          <Skeleton />
        </div>
      </section>
    )

  return (
    <section className="our-properties">
      <div className="slider-container h-screen max-h-[950px]">
        <div className="slider">
          <div className="main-container flex flex-col z-10 h-full">
            {/* Header */}
            <div className="z-20 mt-[130px] md:mt-[108px] mb-auto our-properties__header">
              <h3 className="heading2 text-[45px] md:text-[60px] lg:text-[70px] leading-none uppercase text-white z-10 mb-5">
                {data?.title}
              </h3>

              <SelectAic
                light
                options={properties}
                value={currentProperty}
                onChange={(data) => {
                  onChangeHotel(data)
                }}
              />
            </div>

            {/* Content */}
            <div className="my-auto our-properties__content z-10">
              <div className="flex flex-col gap-1 mb-5">
                <span className="paragraph text-white">{currentProperty?.guestRooms}</span>
                <span className="paragraph text-white">{currentProperty?.restaurants}</span>
                <span className="paragraph text-white">{currentProperty?.minsFromAirport}</span>
              </div>

              <Button
                light
                link={currentProperty?.siteUrl}
                variant="default"
                name="VISIT SITE"
                showLabel
                target="_blank"
              />
            </div>

            {/* Footer */}
            <div className="mt-auto mb-[76px] flex flex-raw justify-between items-center md:flex-col md:justify-start md:items-start gap-3">
              <div className="flex align-center gap-4 z-10">
                <Button
                  action={() => swipeToImage(-1)}
                  type="icon"
                  icon="ArrowLeft"
                  iconFill="transparent"
                  iconStroke={activeColor}
                  strokeCircle={activeColor}
                  strokeOnHover={'#1B1F24'}
                />
                <Button
                  action={() => swipeToImage(1)}
                  type="icon"
                  icon="ArrowRight"
                  iconFill="transparent"
                  iconStroke={activeColor}
                  strokeCircle={activeColor}
                  strokeOnHover={'#1B1F24'}
                />
              </div>
              <span className="paragraph text-white z-10">{`${activeImageIndex + 1} / ${currentProperty?.totalImages}`}</span>
            </div>
          </div>
          <AnimatePresence initial={false} custom={direction}>
            {!isEmpty(currentImage) ? (
              <motion.div
                key={imageCount}
                style={{
                  background: `url(${currentImage?.url})`,
                  boxShadow: `inset 0 0 0 2000px rgba(27, 31, 36, 0.3)`,
                }}
                custom={direction}
                variants={sliderVariants}
                initial="incoming"
                animate="active"
                exit="exit"
                transition={sliderTransition}
                drag="x"
                dragConstraints={{ left: 0, right: 0 }}
                dragElastic={0}
                onDragEnd={(_, dragInfo) => dragEndHandler(dragInfo)}
                className="image"
              />
            ) : null}
          </AnimatePresence>
        </div>
      </div>
    </section>
  )
}
